import { getEnvironment } from "@/utils/environment.ts";
import type { Types } from "@honeybadger-io/core";

export const honeybadgerConfig: Partial<Types.BrowserConfig> = {
    apiKey: import.meta.env.VITE_HONEYBADGER_API_KEY as string,
    // NB: Errors will not be reported when `environment` is "development"
    environment: getEnvironment(),
    revision: import.meta.env.VITE_REVISION as string | undefined,
    filters: ["password", "apikey", "email", "access_token"],
    // debug: true,
};
